if (document.getElementById('page-benefits')) {

  document.addEventListener('DOMContentLoaded', () => {

    if (!document.getElementById('page-benefits')) return;

    const items = document.querySelectorAll('.js-benefitsAcc');

    const setHeight = (item) => {
      const answer = item.querySelector('.js-benefitsAccContents');
      answer.style.height = answer.scrollHeight + 'px';
    };

    items.forEach(item => {

      const answer = item.querySelector('.js-benefitsAccContents');
      if (!answer) return;

      // 初期状態
      if (item.classList.contains('is-open')) {
        setHeight(item);
      }

      item.addEventListener('click', () => {

        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.height = 0;
        } else {
          item.classList.add('is-open');
          setHeight(item);
        }

      });

    });

  });

}
